import React from "react";
const TierCom = (props) => {
    return (
        <div style={{ backgroundColor: props.bgColor }}>
            <div className="">
                <img className="w-full h-72" src={props.awardImg} alt="" />
            </div>
        </div>
    )
}
export default TierCom;